import { toast } from "react-toastify";
import { Constants } from "../constants/constant";
import { SitePath } from "../constants";

function generateUtmSessionId(length = 24) {
    const characters = Constants.UTM_SESSION_CHARACTERS
    let result = "";

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }

    return result;
}

export function setUtmData(query: any) {
    const utmSessionId = generateUtmSessionId(); // Simple session ID generator
    let utmquerydata = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
        /&/g,
        ":<>:"
    )}`;
    const utmId: string = `${query.toString()}&utm_session_id=${utmSessionId}&full_utm_campaign_url=${window.location.href.replace(
        /&/g,
        ":<>:"
    )}`

    return { utmId: utmId, utmquerydata: utmquerydata }

}

 export function converInToLocalCurrency (value:number) {
     if(!value) return '₹ 0'
    return `₹ ${value.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`
 }

 // addressFieldConfig.ts
export const addressFields = [
  { label: "Name", key: "name", required: true },
  { label: "Email", key: "email", required: true },
  { label: "Address 1", key: "address_1", required: true },
  { label: "Address 2", key: "address_2", required: true },
  { label: "Landmark", key: "landmark", required: false },
  { label: "Pincode", key: "pincode", required: true },
  { label: "State", key: "state", required: true, disabled: true },
  { label: "City", key: "city", required: true, disabled: true }
];

export const generateErrorCode = (pageCode:number, localCode:number) => {
    return `ERR:${pageCode}:${localCode} `
}
export const showToastErrorInfo = (text:string) => { 
    toast(text, {
              type:'error',
              theme:'colored'
            })
}

export const showToastError = (pageCode:number, localErrorCode:number, text?:string) => {
    const code = generateErrorCode(pageCode, localErrorCode)
    toast(`${code} ${text ? text : 'Something Went Wrong'}`, {
              type:'error',
               theme:'colored'
            })
}

export const showToastInfo = (text:string) => { 
    toast(text, {
              type:'info',
              theme:'colored'
            })
}

export const showToastWarning = (text:string) => {
    toast(text, {
              type:'warning',
              theme:'colored'
            })
}

export const showToastSuccess = (text:string) => { 
    toast(text, {
              type:'success',
              theme:'colored'
            })
}

export async function getIPAddress() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  const version = process.env.REACT_APP_VERSION;
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    if (response.ok) {
      const data = await response.json();
      if (data?.ip) return data.ip;
    }
    console.warn("IPify failed, falling back to backend...");
  } catch (err) {
    console.warn("IPify error:", err);
  }
 
  try {
    const backendRes = await fetch(`${backendUrl}${version}get-ip`, { credentials: "include" });
    const backendData = await backendRes.json();
 
    if (backendData?.ip) return backendData.ip;
  } catch (err) {
    console.warn("Backend IP fallback failed:", err);
  }
 
  return "0.0.0.0";
}

export const redirectToSellUsed = () => {
  if (typeof window !== "undefined") {

    window.location.assign(SitePath.SELL_NOW_PAGE);
  }
};


export const check_is_cityPopupLoading_enable = () => {
  const localStroageData = localStorage.getItem('persist:root')
  if(localStroageData){
    const parsedData = JSON.parse(localStroageData);
    const parsedGeoInfoData = JSON.parse(parsedData.geoInof)
    console.log('localstorage', parsedData )
    return !parsedGeoInfoData.showCityPopup && parsedGeoInfoData.isLoading
    if(parsedGeoInfoData.isLoading){
       console.log('localstorage 2', parsedData )
      return true
   
  } else{
      return false
    }
  
}
}

